import { render, staticRenderFns } from "./pre_btn_easy.vue?vue&type=template&id=ab93aab2&scoped=true"
import script from "./pre_btn_easy.vue?vue&type=script&lang=js"
export * from "./pre_btn_easy.vue?vue&type=script&lang=js"
import style0 from "./pre_btn_easy.vue?vue&type=style&index=0&id=ab93aab2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab93aab2",
  null
  
)

export default component.exports